import { render } from "./BtnText.vue?vue&type=template&id=2e3924da&scoped=true"
import script from "./BtnText.vue?vue&type=script&lang=js"
export * from "./BtnText.vue?vue&type=script&lang=js"

import "./BtnText.vue?vue&type=style&index=0&id=2e3924da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3924da"]])

export default __exports__